<template lang="pug">
article
  .tracking(@click="goToAction()" :class="{'tracking-pointer': newDesign}")
    .tracking-item-title.g-flex(v-if="showInsuranceID" style="font-weight: 700;; margin-bottom: 5px")
      p N° de póliza: {{ requirement.policy }}
    .tracking-item-title.g-flex
      p {{ title }}
      p N° {{ code }}
    v-layout
      v-flex(xs11 md11 lg11)
        .tracking-item-porcent
          p {{ percent }}%
          div
            aside.transition-all-3(:style="getAdvance()")
      v-flex(xs1 md1 lg1)
        <svg :class="{'arrow-bottom': selectedShow}" style="margin-left: 10px;" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.31002 6.70978C9.21732 6.80229 9.14377 6.91218 9.09359 7.03315C9.04341 7.15413 9.01758 7.28381 9.01758 7.41478C9.01758 7.54575 9.04341 7.67543 9.09359 7.7964C9.14377 7.91738 9.21732 8.02726 9.31002 8.11978L13.19 11.9998L9.31002 15.8798C9.12304 16.0668 9.018 16.3203 9.018 16.5848C9.018 16.8492 9.12304 17.1028 9.31002 17.2898C9.497 17.4768 9.7506 17.5818 10.015 17.5818C10.2794 17.5818 10.533 17.4768 10.72 17.2898L15.31 12.6998C15.4027 12.6073 15.4763 12.4974 15.5265 12.3764C15.5766 12.2554 15.6025 12.1257 15.6025 11.9948C15.6025 11.8638 15.5766 11.7341 15.5265 11.6132C15.4763 11.4922 15.4027 11.3823 15.31 11.2898L10.72 6.69978C10.34 6.31978 9.70002 6.31978 9.31002 6.70978Z" fill="#0855C4"/>
        </svg>
    .tracking-item-estado
      span
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="7" viewBox="0 0 8 7" fill="none">
          <circle cx="3.81364" cy="3.53654" r="3.33073" :fill="estados[status]"/>
        </svg>
        | {{ status }}
    .tracking-item-fecha
      svg(width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg")
        path(d="M13.0029 1.79346C13.5182 1.79346 14.0124 1.99816 14.3768 2.36254C14.7412 2.72692 14.9459 3.22112 14.9459 3.73643V13.0029C14.9459 13.5182 14.7412 14.0124 14.3768 14.3768C14.0124 14.7412 13.5182 14.9459 13.0029 14.9459H3.73643C3.22112 14.9459 2.72692 14.7412 2.36254 14.3768C1.99816 14.0124 1.79346 13.5182 1.79346 13.0029V3.73643C1.79346 3.22112 1.99816 2.72692 2.36254 2.36254C2.72692 1.99816 3.22112 1.79346 3.73643 1.79346H13.0029ZM14.0491 5.68119H2.69021V13.0029C2.69021 13.5804 3.15892 14.0491 3.73643 14.0491H13.0029C13.2804 14.0491 13.5465 13.9389 13.7427 13.7427C13.9389 13.5465 14.0491 13.2804 14.0491 13.0029V5.68119ZM5.23042 10.4627C5.42862 10.4627 5.6187 10.5414 5.75884 10.6816C5.89899 10.8217 5.97772 11.0118 5.97772 11.21C5.97772 11.4082 5.89899 11.5983 5.75884 11.7384C5.6187 11.8786 5.42862 11.9573 5.23042 11.9573C5.03223 11.9573 4.84215 11.8786 4.702 11.7384C4.56186 11.5983 4.48313 11.4082 4.48313 11.21C4.48313 11.0118 4.56186 10.8217 4.702 10.6816C4.84215 10.5414 5.03223 10.4627 5.23042 10.4627ZM8.37146 10.4627C8.56966 10.4627 8.75973 10.5414 8.89988 10.6816C9.04002 10.8217 9.11876 11.0118 9.11876 11.21C9.11876 11.4082 9.04002 11.5983 8.89988 11.7384C8.75973 11.8786 8.56966 11.9573 8.37146 11.9573C8.17326 11.9573 7.98319 11.8786 7.84304 11.7384C7.7029 11.5983 7.62416 11.4082 7.62416 11.21C7.62416 11.0118 7.7029 10.8217 7.84304 10.6816C7.98319 10.5414 8.17326 10.4627 8.37146 10.4627ZM5.23042 7.47351C5.42862 7.47351 5.6187 7.55224 5.75884 7.69239C5.89899 7.83253 5.97772 8.02261 5.97772 8.22081C5.97772 8.419 5.89899 8.60908 5.75884 8.74922C5.6187 8.88937 5.42862 8.9681 5.23042 8.9681C5.03223 8.9681 4.84215 8.88937 4.702 8.74922C4.56186 8.60908 4.48313 8.419 4.48313 8.22081C4.48313 8.02261 4.56186 7.83253 4.702 7.69239C4.84215 7.55224 5.03223 7.47351 5.23042 7.47351ZM8.37146 7.47351C8.56966 7.47351 8.75973 7.55224 8.89988 7.69239C9.04002 7.83253 9.11876 8.02261 9.11876 8.22081C9.11876 8.419 9.04002 8.60908 8.89988 8.74922C8.75973 8.88937 8.56966 8.9681 8.37146 8.9681C8.17326 8.9681 7.98319 8.88937 7.84304 8.74922C7.7029 8.60908 7.62416 8.419 7.62416 8.22081C7.62416 8.02261 7.7029 7.83253 7.84304 7.69239C7.98319 7.55224 8.17326 7.47351 8.37146 7.47351ZM11.5131 7.47351C11.7113 7.47351 11.9014 7.55224 12.0415 7.69239C12.1817 7.83253 12.2604 8.02261 12.2604 8.22081C12.2604 8.419 12.1817 8.60908 12.0415 8.74922C11.9014 8.88937 11.7113 8.9681 11.5131 8.9681C11.3149 8.9681 11.1248 8.88937 10.9847 8.74922C10.8445 8.60908 10.7658 8.419 10.7658 8.22081C10.7658 8.02261 10.8445 7.83253 10.9847 7.69239C11.1248 7.55224 11.3149 7.47351 11.5131 7.47351ZM13.0029 2.69021H3.73643C3.45895 2.69021 3.19285 2.80044 2.99664 2.99664C2.80044 3.19285 2.69021 3.45895 2.69021 3.73643V4.78444H14.0491V3.73643C14.0491 3.45895 13.9389 3.19285 13.7427 2.99664C13.5465 2.80044 13.2804 2.69021 13.0029 2.69021Z" fill="#535D66")
      p {{ slashDate }}
  .tracking-timeline(v-if="selectedShow")
    p(style="width: 100%; padding-left: 5px;") Detalles del seguimiento
    .timeline
      .timeline-component.timeline-content(:class="status==='Finalizado' ? 'timeline-content-active': ''")
        p.timeline-fecha {{ responsedDate }}
        p.timeline-hora {{ responsedTime }}
      .timeline-middle
        .timeline-circle(:class="status==='Finalizado' ? 'timeline-circle-active': ''")
      .timeline-component.timeline-content(:class="status==='Finalizado' ? 'timeline-content-active': ''")
        p.timeline-estado Respuesta de la solicitud
      .timeline-component.timeline-content(:class="['Finalizado', 'En curso'].includes(status) ? 'timeline-content-active': ''")
        p.timeline-fecha {{ sentDate }}
        p.timeline-hora {{ sentTime }}
      .timeline-middle
        .timeline-circle(:class="['Finalizado', 'En curso'].includes(status) ? 'timeline-circle-active': ''")
      .timeline-component.timeline-content(:class="['Finalizado', 'En curso'].includes(status) ? 'timeline-content-active': ''")
        p.timeline-estado Envío de la solicitud
      .timeline-component.timeline-component-first.timeline-content(:class="['Finalizado', 'En curso', 'Creado'].includes(status) ? 'timeline-content-active': ''")
        p.timeline-fecha {{ createdDate }}
        p.timeline-hora {{ createdTime }}
      .timeline-middle.timeline-middle-first
        .timeline-circle(:class="['Finalizado', 'En curso', 'Creado'].includes(status) ? 'timeline-circle-active': ''")
      .timeline-component.timeline-component-first.timeline-content(:class="['Finalizado', 'En curso', 'Creado'].includes(status) ? 'timeline-content-active': ''")
        p.timeline-estado Creación de solicitud
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'

export default {
  props: [
    'title',
    'code',
    'percent',
    'date',
    'selected',
    'status',
    'requirement',
    'home',
    'showInsuranceID',
    'dispositivo',
    'newDesign'
  ],
  data () {
    return {
      selectedShow: this.selected,
      estados: {
        'Creado': '#FFC43A',
        'En curso': '#2DB398',
        'Finalizado': '#EA0C90'
      },
      slashDate: '',
      createdDate: '',
      createdTime: '',
      sentDate: '',
      sentTime: '',
      responsedDate: '',
      responsedTime: ''
    }
  },
  mounted () {
    moment.locale('es')
    const createdAt = moment(this.requirement.created_at, 'YYYY-MM-DD HH:mm:ss')
    const updateAt = moment(this.requirement.updated_at, 'YYYY-MM-DD HH:mm:ss')
    this.slashDate = createdAt.format('DD/MM/YYYY')
    if (this.status === 'Finalizado') {
      this.responsedDate = updateAt.format('DD [de] MMMM')
      this.responsedTime = updateAt.format('h:mm A')
    } else {
      const aux = this.addHours(updateAt, 48)
      this.responsedDate = aux.format('DD [de] MMMM')
      this.responsedTime = aux.format('h:mm A')
    }

    this.createdDate = createdAt.format('DD [de] MMMM')
    this.createdTime = createdAt.format('h:mm A')

    this.sentDate = createdAt.add(1, 'minutes').format('DD [de] MMMM')
    this.sentTime = createdAt.add(1, 'minutes').format('h:mm A')
  },
  methods: {
    ...mapActions('event', ['eventLog']),
    getAdvance () {
      return `width: ${this.percent}%;`
    },
    addHours (m, horas) {
      for (let i = 0; i < horas; i++) {
        m.add(1, 'hours')
        if (m.weekday() === 6) {
          m.add(2, 'days')
        } else if (m.weekday() === 0) {
          m.add(1, 'days')
        }
      }
      return m
    },
    goToAction () {
      if (this.home) {
        this.$emit('goToRequirement', {})
      } else {
        this.selectedShow = !this.selectedShow
        if (this.selectedShow) {
          this.eventLog({
            'categoria': 'Consulta',
            'nombre': 'Tracking de solicitudes',
            'datos': {
              'numeroPoliza': this.requirement.policy,
              'estado': this.status,
              'porcentaje': this.percent,
              'requerimiento': this.requirement,
              'dispositivo': this.dispositivo
            }
          })
        }
      }
    }
  }
}
</script>

<style scoped>

article {
  padding: 0 !important;
  padding-bottom: 10px !important;
  border: 0px !important;
  box-shadow: 0 0 0 #fff !important;
}
.arrow-bottom{
  transform: rotate(90deg);
  transition: .3s ease-in-out;
}

.tracking {
  background: #FFFFFF;
  border: 1.41874px solid #F2F2F2;
  box-sizing: border-box;
  box-shadow: 0px 3.05063px 6px rgba(159, 159, 159, 0.16);
  border-radius: 14.2766px;
  width: 100%;
  transition: .2s ease-in-out;
  padding: 7px 15px 5px;
  cursor: auto;
}
.tracking-pointer{
  cursor: pointer;
}

.inicio-extra-gray {
  align-items: center;
  background: #F2F2F2;
  border-radius: 14.28px;
  display: flex;
  height: 297px;
  justify-content: center;
  margin: auto;
}

.inicio-extra-gray div {
  text-align: center;
}

.inicio-extra-gray p {
  color: #C2C2C2;
  font-size: 16px;
  margin-top: 15px;
}

.tracking-item-title p {
  margin: 0;
  font-size: 13.3px;
  color: #454A6C;
}

.tracking-item-title p:nth-of-type(2) {
  margin-left: 7px;
  color: #0855C4;
  font-size: 13px;
  text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25), 0px 2px 2px rgba(0, 0, 0, 0.25);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-decoration-line: underline;
}

.tracking-item-porcent p {
  color: #0855C4;
  font-size: 10.5px;
  font-weight: 700;
  margin: 0 -8px -3px 0;
}

.tracking-item-porcent p:nth-of-type(1) {
  text-align: right;
}

.tracking-item-porcent div,
.tracking-item-porcent aside {
  border-radius: 8px;
  height: 6px;
}

.tracking-item-porcent div {
  background: #D9D9D9;
  margin-bottom: 10px;
  margin-top: 5px;
  position: relative;
  max-width: 260px;
  z-index: 2;
}

.tracking-item-porcent aside {
  background: var(--first-brand-color);
  left: 0;
  position: absolute;
  top: 0;
  z-index: 5;
}

.tracking-item-estado {
  display: flex;
  justify-content: flex-start;
}

.tracking-item-estado span {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
  border-radius: 14.419px;
  border: 0.833px solid #C4C4C4;
  width: 76px;
  height: 25px;

}

.tracking-item-estado span svg {
  margin: 0 2px 0 5px;
}

.tracking-item-fecha {
  display: flex;
  justify-content: flex-end;
  margin-top: -10px;
}

.tracking-item-fecha svg {
  margin: 2px -5px 0 0px;
}

.tracking-item-fecha p {
  margin: 0;
  font-size: 11.6px;
}

.tracking-item-fecha p {
  color: #919191;
  font-size: 14px;
  margin-left: 7px;
}

.tracking-timeline {
  margin-top: 20px;
  font-size: 15px;
}

.tracking-timeline {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.timeline {
  width: 100%;
  height: auto;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}

.timeline-content {
  padding: 0;
  transition: 0.5s ease;
  overflow-wrap: break-word !important;
}

.timeline-component {
  margin: 0px 0px 40px 5px;
}

.timeline-component-first {
  margin-bottom: 10px;
}

.timeline {
  display: grid;
  grid-template-columns: 1fr 20px 1fr;
}
.timeline-middle {
  position: relative;
  width: 0px;
  height: 75px;
  border-left: 1px dashed #C4C4C4;
}
.timeline-middle-first {
  border: 0;
}
.main-middle {
  opacity: 0;
}
.timeline-circle {
  position: absolute;
  top: 0;
  left: 50%;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
  background: #D4DBEA;
}

.timeline-circle-active {
  background: #0855C4;
}
p.timeline-fecha {
  margin: 0;
  color: #D4DBEA;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 20.528px;
}
p.timeline-hora {
  margin: 0;
  color: #D4DBEA;
  font-size: 13.3px;
  font-style: normal;
  font-weight: 400;
}
p.timeline-estado {
  margin: 0;
  color: #D4DBEA;
  font-size: 13.5px;
  font-style: normal;
  font-weight: 400;
  line-height: 20.528px;
}

.timeline-content-active p.timeline-fecha {
  color: #454A6C;
}
.timeline-content-active p.timeline-hora {
  color: #919191;
}
.timeline-content-active p.timeline-estado {
  color: #454A6C;
}

</style>



// WEBPACK FOOTER //
// src/components/mis-seguros/CardTrackingSolicitudes.vue